import { FormGroup, TextInput } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { useDebounce } from '@frontend/utils/hooks/useDebounce';
import type { OutpatientClinicTaskListFilter } from '../../types/outpatientClinicTaskListFilter';

export type SearchTextFilterProps = {
    filter: OutpatientClinicTaskListFilter;
    localSearchText: string;
    setFilter: (filter: OutpatientClinicTaskListFilter) => void;
    setLocalSearchText: (text: string) => void;
};

export function SearchTextFilter({ filter, setFilter, localSearchText, setLocalSearchText }: SearchTextFilterProps) {
    const translate = getSelectedLanguage();
    const debounce = useDebounce(500);

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value;
        setLocalSearchText(value);

        debounce(() => {
            if (value.length >= 3 || value.length === 0) {
                setFilter({ ...filter, searchText: value.length === 0 ? undefined : value });
            }
        });
    }

    function handleReset() {
        setLocalSearchText('');
        setFilter({ ...filter, searchText: undefined });
    }

    return (
        <FormGroup
            label={translate.request.searchInPatientTasks}
            sx={{
                gridColumn: ['1 / -1', null, '1 / 3', null, 'auto'],
            }}
        >
            <TextInput
                hasSearchIcon={true}
                onChange={handleChange}
                onReset={handleReset}
                value={localSearchText}
            />
        </FormGroup>
    );
}
